import _ from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Query } from '@apollo/react-components';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import SpinnerError from '$components/library/SpinnerError';
import { gql } from '@apollo/client';
import styles from './styles.scss';

const STAFF_PRODUCTS = gql`
  query StaffProducts {
    staffProducts {
      products {
        uuid
        slug
        name
      }
    }
  }
`;

class Products extends Component {
  render() {
    return (
      <Query query={STAFF_PRODUCTS}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          const { staffProducts } = data;
          const { products } = staffProducts;

          return (
            <div className={styles.layout}>
              Hi, this is staff products.
              <br />
              <br />
              <ul>
                {_.sortBy(products, 'name').map((product) => {
                  const { name, slug: productSlug } = product;
                  return (
                    <li key={product.uuid}>
                      <Link to={reverse(routes.staff.product.overview, { productSlug })}>
                        {name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default Products;
